/* ==========================================================================
   Sound module.

   The toy has two press-points and one speaker: pressing the tummy again while
   it is singing moves to the NEXT song, and pressing the hand starts meditation
   mode. This mirrors that exactly — a press-point with several tracks advances
   through them, and the press after the last one stops. So the page behaves the
   way the object in the box behaves, which is the whole point of the section.

   One <audio> element, src swapped. Not one element per track: iOS unlocks
   playback per ELEMENT on a user gesture, so an element that first meets a
   src outside a gesture can never play. Swapping the src on the element the
   user already tapped keeps every later track playable.

   With this file blocked the photo, the labels and the track list all still
   render; the buttons simply do nothing.
   ========================================================================== */
(function () {
  'use strict';

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function init(root) {
    var audio = root.querySelector('[data-cs-audio]');
    if (!audio) return;

    var spots = Array.prototype.slice.call(root.querySelectorAll('[data-cs-spot]'));
    var tracks = Array.prototype.slice.call(root.querySelectorAll('[data-cs-track]'));
    var now = root.querySelector('[data-cs-now]');
    var nowTitle = root.querySelector('[data-cs-nowtitle]');
    var nowTime = root.querySelector('[data-cs-nowtime]');
    var bar = root.querySelector('[data-cs-bar]');
    var stopBtn = root.querySelector('[data-cs-stop]');

    /* tracks grouped by the spot they belong to. The button's data-cs-track is
       "<spotIndex>:<trackIndex>", written by Liquid from the same loop that
       wrote the spots, so the two surfaces cannot fall out of step. */
    var bySpot = {};
    tracks.forEach(function (btn) {
      var parts = (btn.getAttribute('data-cs-track') || '').split(':');
      var s = parts[0];
      (bySpot[s] = bySpot[s] || []).push(btn);
    });

    var current = null; // the track button that is playing

    function paint() {
      spots.concat(tracks).forEach(function (el) {
        var on = false;
        if (current) {
          if (el.hasAttribute('data-cs-track')) {
            on = el === current;
          } else {
            on = el.getAttribute('data-cs-spot') === current.getAttribute('data-cs-track').split(':')[0];
          }
        }
        el.classList.toggle('is-playing', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (current) {
        nowTitle.textContent = current.getAttribute('data-cs-title') || '';
        now.hidden = false;
      } else {
        now.hidden = true;
        if (bar) bar.style.width = '0';
        if (nowTime) nowTime.textContent = '0:00';
      }
    }

    function stop() {
      audio.pause();
      try { audio.currentTime = 0; } catch (e) { /* not seekable yet */ }
      current = null;
      paint();
    }

    function play(btn) {
      var src = btn.getAttribute('data-cs-src');
      if (!src) return;
      /* Assigning the same src again would restart the download on some
         browsers; only touch it when it actually changes. */
      if (audio.getAttribute('src') !== src) audio.setAttribute('src', src);
      audio.loop = btn.hasAttribute('data-cs-loop');
      try { audio.currentTime = 0; } catch (e) {}
      current = btn;
      paint();
      var p = audio.play();
      /* A rejected play() (autoplay policy, a missing file) must not leave the
         UI claiming to be playing. */
      if (p && typeof p.catch === 'function') {
        p.catch(function () { if (current === btn) { current = null; paint(); } });
      }
    }

    /* A press-point: start its first track, or advance to the next one, or —
       after the last — stop. Exactly what the physical button does. */
    spots.forEach(function (spot) {
      spot.addEventListener('click', function () {
        var list = bySpot[spot.getAttribute('data-cs-spot')] || [];
        if (!list.length) return;
        var at = list.indexOf(current);
        if (at === -1) play(list[0]);
        else if (at + 1 < list.length) play(list[at + 1]);
        else stop();
      });
    });

    /* A named track in the list: play it, or stop it if it is the one playing. */
    tracks.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (current === btn) stop();
        else play(btn);
      });
    });

    if (stopBtn) stopBtn.addEventListener('click', stop);

    audio.addEventListener('timeupdate', function () {
      if (!current) return;
      if (nowTime) nowTime.textContent = fmt(audio.currentTime);
      if (bar && audio.duration && isFinite(audio.duration)) {
        bar.style.width = (audio.currentTime / audio.duration * 100) + '%';
      }
    });

    /* End of a track inside a multi-track point rolls on to the next, so the
       three songs play as a set if you leave it alone. A looping track never
       fires this. */
    audio.addEventListener('ended', function () {
      if (!current) return;
      var list = bySpot[current.getAttribute('data-cs-track').split(':')[0]] || [];
      var at = list.indexOf(current);
      if (at > -1 && at + 1 < list.length) play(list[at + 1]);
      else stop();
    });

    audio.addEventListener('error', stop);

    /* Sound that follows you down the page is the fastest way to make someone
       leave. Stop when the section is fully out of view, and when the tab goes
       away. */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting && current) stop();
      }, { threshold: 0 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && current) stop();
    });

    /* Two sound modules on one page must not talk over each other. */
    root.addEventListener('cs:sound-play', function () {});
    document.addEventListener('cs:sound-start', function (e) {
      if (e.detail !== root && current) stop();
    });
    audio.addEventListener('play', function () {
      document.dispatchEvent(new CustomEvent('cs:sound-start', { detail: root }));
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-cs-sound]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
